/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const ParametersTabStyles = makeStyles({
  root: {
    width: '100%',
  },
  buttonWrapper: {
    marginTop: 16,
  },
  form: {
    '& .MuiGrid-root': {
      margin: 0,
      '& > .MuiGrid-item': {
        padding: 0,
        marginBottom: 0,
      },
    },
    '& .MuiGrid-container': {
      marginTop: 0,
      '& > .MuiGrid-item': {
        paddingTop: 0,
        paddingLeft: 0,
      },
    },
  },
});
